var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 120,
    viewBox: "0 0 137 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.153 1.40253H23.4102V118.597H115.287V16.4656L100.153 1.40253Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.288 120H23.4105C22.6347 120 22 119.369 22 118.597V1.40252C22 0.631136 22.6347 0 23.4105 0H100.153C100.534 0 100.887 0.154278 101.155 0.406732L116.289 15.4698C116.557 15.7363 116.698 16.087 116.698 16.4656V118.597C116.698 119.369 116.063 120 115.288 120ZM24.8209 117.195H113.877V17.0407L99.561 2.80505H24.8209V117.195Z",
    fill: "#3C2163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.152 16.4656H115.287L100.152 1.40253V16.4656Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.287 17.8682H100.153C99.3769 17.8682 98.7422 17.237 98.7422 16.4656V1.40253C98.7422 0.841518 99.0807 0.322584 99.6167 0.112205C100.139 -0.112199 100.745 0.0140282 101.154 0.42076L116.288 15.4839C116.697 15.8906 116.81 16.4937 116.599 17.0126C116.387 17.5316 115.865 17.8822 115.301 17.8822L115.287 17.8682ZM101.563 15.0631H111.888L101.563 4.79664V15.0631Z",
    fill: "#3C2163"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1863 46.3248H36.9492V54.5155H45.1863V46.3248Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.597 55.904H35.5391V44.9082H46.597V55.904ZM38.36 53.0989H43.7761V47.7133H38.36V53.0989Z",
    fill: "#8FDAE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0304 51.8227H53.4222C52.6464 51.8227 52.0117 51.1915 52.0117 50.4201C52.0117 49.6487 52.6464 49.0176 53.4222 49.0176H75.0304C75.8061 49.0176 76.4408 49.6487 76.4408 50.4201C76.4408 51.1915 75.8061 51.8227 75.0304 51.8227Z",
    fill: "#3C2163"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1863 63.7161H36.9492V71.9068H45.1863V63.7161Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.597 73.3093H35.5391V62.3135H46.597V73.3093ZM38.36 70.5043H43.7761V65.1186H38.36V70.5043Z",
    fill: "#8FDAE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0304 69.214H53.4222C52.6464 69.214 52.0117 68.5828 52.0117 67.8114C52.0117 67.04 52.6464 66.4089 53.4222 66.4089H75.0304C75.8061 66.4089 76.4408 67.04 76.4408 67.8114C76.4408 68.5828 75.8061 69.214 75.0304 69.214Z",
    fill: "#3C2163"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1863 81.1214H36.9492V89.3121H45.1863V81.1214Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.597 90.7147H35.5391V79.7189H46.597V90.7147ZM38.36 87.9096H43.7761V82.5239H38.36V87.9096Z",
    fill: "#8FDAE2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0304 86.6193H53.4222C52.6464 86.6193 52.0117 85.9882 52.0117 85.2168C52.0117 84.4454 52.6464 83.8142 53.4222 83.8142H75.0304C75.8061 83.8142 76.4408 84.4454 76.4408 85.2168C76.4408 85.9882 75.8061 86.6193 75.0304 86.6193Z",
    fill: "#3C2163"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.264 51.5002C96.4864 51.5002 86.9376 60.9953 86.9376 72.7064C86.9376 77.7975 88.743 82.4679 91.7473 86.1285C89.9701 91.977 83.75 93.9266 83.75 93.9266H107.869C108.01 93.9266 108.137 93.9266 108.278 93.9266C120.055 93.9266 129.604 84.4315 129.604 72.7204C129.604 61.0093 120.055 51.5142 108.278 51.5142L108.264 51.5002Z",
    fill: "#EAEAF9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.351 95.315H83.7356L83.3125 92.5801C83.3125 92.5801 88.376 90.9251 90.1532 86.395C87.163 82.4819 85.5128 77.6573 85.5128 72.7064C85.5128 60.2379 95.7104 50.0977 108.249 50.0977C120.788 50.0977 130.986 60.2379 130.986 72.7064C130.986 84.4876 121.874 94.2071 110.28 95.2309L110.337 95.315H110.351ZM104.371 92.4259L108.249 92.51C119.237 92.51 128.165 83.618 128.165 72.7064C128.165 61.7947 119.223 52.9027 108.249 52.9027C97.276 52.9027 88.3337 61.7947 88.3337 72.7064C88.3337 77.2646 89.9275 81.7106 92.8331 85.2309L93.3126 85.8059L93.1011 86.5212C92.283 89.2 90.661 91.1496 89.0248 92.51H104.469L104.385 92.4259H104.371Z",
    fill: "#3C2163"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.037 64.5296H99.5039V67.3347H118.037V64.5296Z",
    fill: "#F58B93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.037 72.2996H99.5039V75.1047H118.037V72.2996Z",
    fill: "#F58B93"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.037 80.0696H99.5039V82.8747H118.037V80.0696Z",
    fill: "#F58B93"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.849 34.8936L125.867 39.8997L130.847 44.9076L135.829 39.9015L130.849 34.8936Z",
    fill: "#F7D979"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.884 45.83C130.641 45.83 130.423 45.7324 130.253 45.5614L125.273 40.556C124.909 40.1897 124.909 39.6281 125.273 39.2619L130.228 34.2564C130.569 33.9145 131.176 33.9145 131.516 34.2564L136.495 39.2619C136.86 39.6281 136.86 40.1897 136.495 40.556L131.516 45.5614C131.346 45.7324 131.127 45.83 130.884 45.83ZM127.192 39.8967L130.884 43.6081L134.576 39.8967L130.884 36.1853L127.192 39.8967Z",
    fill: "#705699"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5923 26.9434H36.4297V29.7484H71.5923V26.9434Z",
    fill: "#2F4382"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6583 33.5352H36.4297V36.3403H48.6583V33.5352Z",
    fill: "#2F4382"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6615 101.725H37.543V104.53H41.6615V101.725Z",
    fill: "#2F4382"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7162 101.725H45.5977V104.53H49.7162V101.725Z",
    fill: "#2F4382"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.767 101.725H53.6484V104.53H57.767V101.725Z",
    fill: "#2F4382"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55792 85.7201H1.37286C0.60406 85.7201 0 85.115 0 84.3447C0 83.5745 0.60406 82.9693 1.37286 82.9693H4.55792C5.32672 82.9693 5.93078 83.5745 5.93078 84.3447C5.93078 85.115 5.32672 85.7201 4.55792 85.7201Z",
    fill: "#F58B93"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3704 85.7201H10.1854C9.41656 85.7201 8.8125 85.115 8.8125 84.3447C8.8125 83.5745 9.41656 82.9693 10.1854 82.9693H13.3704C14.1392 82.9693 14.7433 83.5745 14.7433 84.3447C14.7433 85.115 14.1392 85.7201 13.3704 85.7201Z",
    fill: "#F58B93"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38458 82.9143C6.61578 82.9143 6.01172 82.3091 6.01172 81.5389V78.3754C6.01172 77.6052 6.61578 77 7.38458 77C8.15339 77 8.75745 77.6052 8.75745 78.3754V81.5389C8.75745 82.3091 8.15339 82.9143 7.38458 82.9143Z",
    fill: "#F58B93"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38458 91.7445C6.61578 91.7445 6.01172 91.1393 6.01172 90.3691V87.1781C6.01172 86.4079 6.61578 85.8027 7.38458 85.8027C8.15339 85.8027 8.75745 86.4079 8.75745 87.1781V90.3691C8.75745 91.1393 8.15339 91.7445 7.38458 91.7445Z",
    fill: "#F58B93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem8);
export default __webpack_public_path__ + "static/media/item8.8937ce530b3b2c57172cc66e93ead96e.svg";
export { ForwardRef as ReactComponent };